import { Activity } from '../shared/activity';
import { TenantNotificationEvent } from '../sockets/tenant.notification.event';

export interface ClaimActivityRequest {
    notification?: TenantNotificationEvent;
    activities: Activity[];
}

export interface ClaimActivities {
    remote: Activity[];
    local: Activity[];
}

export const emptyClaimActivities = {
    remote: [],
    local: []
}